export const ALL_USERS_RECEIVED = 'petdata/ALL_USERS_RECEIVED';
export const SET_USER_LIST_DIRTY = 'petdata/SET_USER_LIST_DIRTY';

export const SELECT_USER = 'petdata/SELECT_USER';
export const DESELECT_USER = 'petdata/DESELECT_USER';

export const REGISTER_USER_ATTEMPT = 'petdata/REGISTER_USER_ATTEMPT';
export const REGISTER_USER_SUCCESS = 'petdata/REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAIL = 'petdata/REGISTER_USER_FAIL';

export const INITIALIZE_PERMISSION_TABLE = 'petdata/INITIALIZE_PERMISSION_TABLE';
export const TOGGLE_USER_PERMISSION = 'petdata/TOGGLE_USER_PERMISSION';

export const SAVE_USER_ATTEMPT = 'petdata/SAVE_USER_ATTEMPT';
export const SAVE_USER_SUCCESS = 'petdata/SAVE_USER_SUCCESS';
export const SAVE_USER_FAIL = 'petdata/SAVE_USER_FAIL';

export const USER_PASSWORD_CHANGED = 'petdata/USER_PASSWORD_CHANGED';

export const SHOW_ERROR_MODAL = 'petdata/SHOW_ERROR_MODAL';




/** WEBPACK FOOTER **
 ** ./src/modules/users/actionTypes.js
 **/